import "./CommentsForm.scss";
import comment from "../../assets/Icons/add_comment.svg";
import avatar from "../../assets/Images/Mohan-muruge.jpg";

//once the comment is submitted, function checks if the input is valid.

export default function CommentsForm({
  commentsCount,
  videoId,
  submitComment,
}) {
  onchange = (e) => {
    const comment = e.target;
    if (comment.value.length > 0) {
      comment.classList.remove("form__input--error");
    } else {
      comment.classList.add("form__input--error");
    }
  };
  return (
    <div className="comments">
      <div className="comments__wrapper">
        <div className="comments__form">
          <p className="comments__count">{commentsCount} Comments</p>
          <div className="form">
            <img className="form__avatar" src={avatar} alt="Mohan-muruge" />
            <form
              className="form__section"
              onSubmit={(e) => submitComment(e, videoId)}
            >
              <label htmlFor="comment" className="label-btn form__label">
                join the conversation
                <textarea
                  id="comment"
                  name="comment"
                  className="form__input input"
                  placeholder="Add a new comment"
                  onChange={onchange}
                ></textarea>
              </label>
              <button type="submit" className="label-btn btn">
                <img className="btn__img" src={comment} alt="comment" />{" "}
                <span className="btn__text">comment</span>{" "}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
